<template>
  <tm-managed-tooltip-wrapper
    v-for="tooltip in tooltips"
    :key="tooltip.id"
    :data="tooltip.tooltipData"
    :anchor-element="tooltip.anchorElement"
    @close-animation-end="unregisterTooltip(tooltip.anchorElement)"
  />
</template>

<script setup lang="ts">
import TmManagedTooltipWrapper from '@/components/shared/tooltip/TmManagedTooltipWrapper.vue'
import { useTooltipManager } from '@/composition/tooltip/useTooltipManager'

const { tooltips, unregisterTooltip } = useTooltipManager()
</script>
